import makeEditContext from './makeEditContext';

export const { Provider: DeleteDialogContextProvider, useContext: useDeleteDialogContext } =
  makeEditContext();
